import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { IconRegularDelivery } from '@notino/react-styleguide-v20';

import { ReactFCV } from '@types';

import { StyledEngravingItemBody, StyledSubName } from './styled';

interface IEngravingItemBodyProps {
  engravingText: string;
  engravingLabel: MessageDescriptor;
  engravingDeliveryTimeDelay: MessageDescriptor;
}

export const EngravingItemBody: ReactFCV<IEngravingItemBodyProps> = ({
  engravingText,
  engravingLabel,
  engravingDeliveryTimeDelay,
  ...rest
}) => (
  <StyledEngravingItemBody {...rest}>
    <FormattedMessage {...engravingLabel} /> <span>{engravingText}</span>
    <StyledSubName>
      <IconRegularDelivery color={'icon.tertiary'} width="16px" height="16px" />
      <FormattedMessage {...engravingDeliveryTimeDelay} />
    </StyledSubName>
  </StyledEngravingItemBody>
);
